import { Button } from "@/components/ui/button";
import { Loader2 } from "@/components/icons";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  saving?: boolean;
  savedLabel?: string;
};

export function SavingButton({ saving, savedLabel, children, disabled, ...rest }: Props) {
  return (
    <Button disabled={saving || disabled} {...rest}>
      {saving ? (
        <>
          <Loader2 className="me-2 h-4 w-4 animate-spin" />
          {savedLabel ?? "Saving…"}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
